module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0142.jpg?v=0f2a9c79";